// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"Login_image-wrapper__2OAjf"};